
//Form
import FormDashboard from "../Ui/Dashboard/DashboardPage";
import FormAcessos from "../Forms/AcessosForm";
import FormAcessosRegras from "../Forms/AcessosRegrasForm";
import FormPermissaoAcesso from "../Forms/PermissaoAcessoForm";
import FormAgendaPacote from "../Forms/AgendamentoPacoteForm";
import FormAgendamentos from "../Forms/AgendamentosForm";
import FormCadastros from "../Forms/CadastrosForm";
import FormHorarios from "../Forms/HorariosForm";
import FormHorariosFechamentos from "../Forms/HorariosFechamentosForm";
import FormEspecialidades from "../Forms/EspecialidadesForm";
import FormFaltas from "../Forms/FaltasForm";
import FormCancelamentos from "../Forms/CancelamentosForm";
import FormAvisos from "../Forms/AvisosForm";
import FormVendas from "../Forms/VendasForm";
import FormProdutos from "../Forms/ProdutosForm";
import FormProdutosVendas from "../Forms/ProdutosVendasForm";
import FormEstoque from "../Forms/EstoqueForm";
import FormFormaPagto from "../Forms/FormaPagtoForm";
import FormCompras from "../Forms/ComprasForm";
import FormComprasItens from "../Forms/CompraItensForm";
import FormFornecedores from "../Forms/FornecedoresForm";
import FormFornecedoresCategorias from "../Forms/FornecedoresCategoriasForm";
import FormDespesas from "../Forms/DespesasForm";
import FormDespesasCategorias from "../Forms/DespesasCategoriasForm";
import FormDespesasItens from "../Forms/DespesaItensForm";
import FormReceitas from "../Forms/ReceitasForm";
import FormMetas from "../Forms/MetasForm";
import FormConfiguracoes from "../Forms/ConfiguracoesForm";
import FormDados from "../Forms/DadosSistemaForm";

export const formsMap = {
  //DASHBOARD
  dashboard:FormDashboard,

  // CADASTROS
  cadastros: FormCadastros,
  acessos: FormAcessos,
  acessosregras: FormAcessosRegras,
  permissao:FormPermissaoAcesso,
  avisos: FormAvisos,
  especialidades: FormEspecialidades,

  //HORÁRIOS
  horarios: FormHorarios,
  horariosfechamento: FormHorariosFechamentos,

  // AGENDAMENTOS
  pacotes: FormAgendaPacote,
  agendamentos: FormAgendamentos,
  faltas: FormFaltas,
  cancelamentos: FormCancelamentos,
  

  // VENDAS
  vendas: FormVendas,
  produtos: FormProdutos,
  produtosvendas:FormProdutosVendas,
  estoque: FormEstoque,
  formapagto: FormFormaPagto,

  // COMPRAS
  compras:FormCompras,
  comprasitens: FormComprasItens,
  fornecedores: FormFornecedores,
  fornecedorescategorias: FormFornecedoresCategorias,

  // FINANCEIRO
  despesas: FormDespesas,
  despesascategorias: FormDespesasCategorias,
  despesasitens: FormDespesasItens,
  receitas: FormReceitas,
  metas:FormMetas,

  // CONFIGURAÇÕES
  configuracoes: FormConfiguracoes,
  dados:FormDados
};